document.addEventListener('DOMContentLoaded', function() {
    let productFieldset = document.querySelector('.product__info-wrapper product-info variant-radios  fieldset.js.product-form__input');
    let productRadios = productFieldset.querySelectorAll('input[type="radio"]');
    let newVariantWithEmptyType = null;
    let anyNewVariant = null;
    let saleVariants = [];

    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
  
    if (!variantId) {
        for (let radio of productRadios) {
            let label = document.querySelector(`label[for="${radio.id}"]`);
            let variantNamePrice = label.querySelector('.variant-name-price').textContent;
            let variantTypeName = label.querySelector('.variant-type-name').textContent.trim();
            let isDisabled = radio.classList.contains('disabled');

            let compareAtPrice = radio.getAttribute("data-compare-at-price");
            let priceValue = radio.getAttribute("data-price-value");

            if (compareAtPrice && !isDisabled) {
                let priceValueNumber = parseFloat(priceValue.replace(/[\$,]/g, ''));
                saleVariants.push({radio: radio, price: priceValueNumber});
            }

            if (variantNamePrice.includes('New') && !isDisabled)
                anyNewVariant = radio;
                if (!variantTypeName && !isDisabled) {
                    newVariantWithEmptyType = radio;
                    break;
                }
            }
        }

        saleVariants.sort((a, b) => a.price - b.price);
        if (saleVariants.length > 0) {
            saleVariants[0].radio.click();
        } else if (newVariantWithEmptyType) {
            newVariantWithEmptyType.click();
        } else if (anyNewVariant) {
            anyNewVariant.click();
        } else {
        for (let radio of productRadios) {
            if (radio.value == variantId) {
                radio.click();
                break;
            }
        }
    }
    const radioButtons = document.querySelectorAll('.product__info-wrapper variant-radios input[type="radio"]');
    radioButtons.forEach(function(radio) {
        radio.addEventListener('change', function(event) {
            updateProductTitle(event);
            updateProductDescription(event);
            updateProductFeatures(event);
            //updateProductSpecs(event);
            updateProductInthebox(event);
            updateProductMPN(event);
            updateProductUPC(event);
            updateProductCondition(event);
        });
    });
    function updateProductTitle(event) {
        const nameMetafield = event.target.getAttribute('data-name-metafield');
        const productTitle = document.querySelector('.product__title h1');
        const productTag = document.querySelector('.product__title h2');
        const productBreadcrums = document.querySelector('section.breadcrumbs.page-width nav.breadcrumb span:nth-child(3)');
        const additionalAttributesProductName = document.querySelector('.additional-attributes-wrapper.table-wrapper table#product-attribute-specs-table td.col.data[data-th="Product Name"]');

        if (nameMetafield) {
            if (productTitle) {
                productTitle.textContent = nameMetafield;
            }
            if(productBreadcrums){
                productBreadcrums.textContent = nameMetafield;
            }
            if (productTag) {
                productTag.textContent = nameMetafield;
            }
            if (additionalAttributesProductName) {
                additionalAttributesProductName.textContent = nameMetafield;
            }
        }
    }
    function updateProductDescription(event) {
        const descriptionMetafield = event.target.getAttribute('data-metafield-description');
        const productDescription = document.querySelector('.product__description.rte');

        if (descriptionMetafield) {
            if (productDescription) {
                productDescription.innerHTML = descriptionMetafield;
            }
        }
    }
    function updateProductFeatures(event) {
        const featureMetafield = event.target.getAttribute('data-metafield-features');
        const productFeatures = document.querySelector('#tab-specs');

        if (featureMetafield) {
            if (productFeatures) {
                productFeatures.innerHTML = featureMetafield;
            }
        }
    }
    //New Functions for refreshing Specs, In the box, MPN, UPC, and Item condition
    /*function updateProductSpecs(event) {
        const specsMetafield = event.target.getAttribute('data-metafield-specs');
        const productSpecs = document.querySelector('#tab-delivery');

        if (specsMetafield) {
            if (productSpecs) {
                productSpecs.innerHTML = specsMetafield;
            }
        }
    }*/
    function updateProductInthebox(event) {
        const IntheboxMetafield = event.target.getAttribute('data-metafield-inthebox');
        const productInthebox = document.querySelector('#tab-inthebox');

        if (IntheboxMetafield) {
            if (productInthebox) {
                productInthebox.innerHTML = IntheboxMetafield;
            }
        }
    }
    function updateProductMPN(event) {
        const MPNMetafield = event.target.getAttribute('data-metafield-mpn');
        const productMPN = document.querySelector('.additional-attributes-wrapper.table-wrapper table#product-attribute-specs-table td.col.data[data-th="MPN"]');

        if (MPNMetafield) {
            if (productMPN) {
                productMPN.innerHTML = MPNMetafield;
            }
        }
    }
    function updateProductUPC(event) {
        const UPCMetafield = event.target.getAttribute('data-metafield-upc');
        const productUPC = document.querySelector('#UPCCodeMetafield');

        if (UPCMetafield) {
            if (productUPC) {
                productUPC.innerHTML = '<th class="col label" scope="row">UPC</th><td class="col data" data-th="UPC">' + UPCMetafield + '</td>';
            }
        } else {
            if (productUPC) {
                productUPC.innerHTML = '';
            }
        }
    }
    function updateProductCondition(event) {
        const ConditionMetafield = event.target.getAttribute('data-metafield-condition');
        const productCondition = document.querySelector('.additional-attributes-wrapper.table-wrapper table#product-attribute-specs-table td.col.data[data-th="Condition"]');

        if (ConditionMetafield) {
            if (productCondition) {
                productCondition.innerHTML = ConditionMetafield;
            }
        }
    }
    //Add Click Event to the Blink Image for the Popup
    setTimeout(() => {
        let blinkImages = document.querySelectorAll('.blink-container img');
        let blinkModal = document.querySelector('.blink-modal-inner-wrap');
        let body = document.body;
        blinkImages.forEach(blinkImage => {
            blinkImage.addEventListener('click', function() {
                if (blinkModal) {
                    blinkModal.style.display = 'block';
                    blinkModal.style.opacity = '1';
                    body.classList.add('blink-modal-opened');
                }
            });
        });
        let closeButton = blinkModal ? blinkModal.querySelector('.action-close') : null;
        if (closeButton) {
            closeButton.addEventListener('click', function() {
                blinkModal.style.display = 'none';
                blinkModal.style.opacity = '0';
                body.classList.remove('blink-modal-opened');
            });
        }
    }, 500);

});

document.addEventListener('DOMContentLoaded', function () {
    var cfg = window.altoDeliveryGate;
    if (!cfg || !cfg.enabled) return;
    var root = document.documentElement;

    function reveal() { root.classList.remove('alto-geo-gating'); }

    function decide(inArea) {
        window.altoGeoDecided = true;
        if (inArea) reveal();
    }

    var originLat = parseFloat(cfg.lat);
    var originLng = parseFloat(cfg.lng);
    var radius = parseFloat(cfg.radius);
    if (isNaN(originLat) || isNaN(originLng) || isNaN(radius)) { decide(true); return; }

    function haversineMiles(lat1, lon1, lat2, lon2) {
        var toRad = function (deg) { return deg * Math.PI / 180; };
        var earthRadiusMiles = 3958.8;
        var dLat = toRad(lat2 - lat1);
        var dLon = toRad(lon2 - lon1);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return earthRadiusMiles * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    fetch('https://get.geojs.io/v1/ip/geo.json')
        .then(function (res) { return res.ok ? res.json() : Promise.reject(); })
        .then(function (data) {
            var lat = parseFloat(data.latitude);
            var lng = parseFloat(data.longitude);
            if (isNaN(lat) || isNaN(lng)) { decide(true); return; }
            decide(haversineMiles(originLat, originLng, lat, lng) <= radius);
        })
        .catch(function () { decide(true); });
});
document.addEventListener('DOMContentLoaded', function () {
    function applyInfoLayout() {
        var inventory = document.querySelector('.product__inventory');
        var priceBlock = document.querySelector('.price-blink-container [id^="price-"]');
        if (inventory && priceBlock && priceBlock.parentNode && inventory.parentNode !== priceBlock.parentNode) {
            priceBlock.parentNode.insertBefore(inventory, priceBlock.nextSibling);
        }
        var trustRow = document.querySelector('.product-trust-row');
        var productForm = document.querySelector('.product__info-container .product-form');
        var buyForm = productForm ? productForm.querySelector('form.form') : null;
        if (trustRow && buyForm && buyForm.nextElementSibling !== trustRow) {
            productForm.insertBefore(trustRow, buyForm.nextSibling);
        }
        var share = document.querySelector('.product__info-container share-button');
        if (share && trustRow && trustRow.parentNode && trustRow.nextElementSibling !== share) {
            trustRow.parentNode.insertBefore(share, trustRow.nextSibling);
        }
    }
    applyInfoLayout();

    var infoContainer = document.querySelector('.product__info-container');
    if (infoContainer) {
        var relayoutQueued = false;
        new MutationObserver(function () {
            if (relayoutQueued) return;
            relayoutQueued = true;
            requestAnimationFrame(function () {
                relayoutQueued = false;
                applyInfoLayout();
            });
        }).observe(infoContainer, { childList: true, subtree: true });
    }

    var titleSoldOutBadge = document.querySelector('.product__title-sold-out');
    var priceContainer = document.querySelector('.product__info-container [id^="price-"]');
    function syncSoldOutBadge() {
        if (!titleSoldOutBadge || !priceContainer) return;
        var priceEl = priceContainer.querySelector('.price');
        if (priceEl) titleSoldOutBadge.hidden = !priceEl.classList.contains('price--sold-out');
    }
    if (titleSoldOutBadge && priceContainer) {
        syncSoldOutBadge();
        new MutationObserver(syncSoldOutBadge).observe(priceContainer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    function findReviewWidgetBlock() {
        var blocks = document.querySelectorAll('.shopify-app-block');
        for (var i = 0; i < blocks.length; i++) {
            var w = blocks[i].querySelector('.jdgm-widget');
            if (w && !w.classList.contains('jdgm-preview-badge')) return blocks[i];
        }
        return null;
    }

    function currentTarget() {
        var isMobile = window.matchMedia('(max-width: 750px)').matches;
        return document.querySelector('[data-reviews-target="' + (isMobile ? 'mobile' : 'desktop') + '"]');
    }

    function place() {
        var block = findReviewWidgetBlock();
        var target = currentTarget();
        if (!block || !target) return false;
        if (target.contains(block)) { block.classList.add('jdgm-placed'); return true; }
        target.appendChild(block);
        block.classList.add('jdgm-placed');
        return true;
    }

    
    function openReviewsPanel() {
        var target = currentTarget();
        if (!target) return null;

        var panel = target.closest('.shopify-tab-content');
        if (panel) {
            var tab = document.querySelector('.shopify-tabs li[data-tab="' + panel.id + '"]');
            // Click the tab so the theme's own handler moves the .current class.
            if (tab && !tab.classList.contains('current')) tab.click();
            // Land on the tab strip, so Reviews reads as the selected tab.
            return document.getElementById('reviews1') || panel;
        }

        var item = target.closest('.accordion-item');
        if (!item) return target;
        var content = item.querySelector('.accordion-content');
        // Mobile keeps this panel open with its header hidden, so usually there is
        // nothing to open. Only act when the reviews really are collapsed.
        if (content && content.getBoundingClientRect().height === 0) {
            var header = item.querySelector('.accordion-header');
            if (header && header.offsetParent) header.click(); // theme's toggleAccordion
            else content.style.display = 'block';
        }
        return item;
    }

    // Capture phase: Judge.me's badge handler stops the click from bubbling, and
    // its own scroll would overshoot the tab strip, so keep the click to ourselves.
    document.addEventListener('click', function (event) {
        if (!event.target.closest('.product__info-container .jdgm-preview-badge')) return;

        event.preventDefault();
        event.stopPropagation();

        var panel = openReviewsPanel();
        if (!panel) return;

        // Next frame, so the panel is laid out before we measure where to scroll.
        requestAnimationFrame(function () {
            panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }, true);

    var tries = 0;
    var poll = setInterval(function () {
        tries += 1;
        if (place() || tries >= 60) clearInterval(poll);
    }, 300);

    setTimeout(function () {
        var pending = document.querySelectorAll('.shopify-app-block:not(.jdgm-placed)');
        for (var i = 0; i < pending.length; i++) {
            var w = pending[i].querySelector('.jdgm-review-widget');
            if (w) pending[i].classList.add('jdgm-placed');
        }
    }, 20000);

    window.addEventListener('resize', function () {
        clearTimeout(window.__altoReviewsMove);
        window.__altoReviewsMove = setTimeout(place, 250);
    });
});

// Soft-swap the financing lines on variant change. Affirm's <p> lives inside the
// price block, so product-info.js wipes it and Affirm only re-renders it several
// hundred ms later, leaving a blank gap that pops back in. Instead we refill it
// with the outgoing copy the moment the block is replaced, dim both financing
// lines to signal "updating", and fade back up once Affirm has repainted.
document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    const priceBlock = productInfo.querySelector('[id^="price-"]');
    if (!priceBlock) return;

    const PENDING_CLASS = 'is-pending-update';
    const RENDER_MS = 450; // Affirm repaints a few frames after refresh()
    const FALLBACK_MS = 2000; // sold-out variants publish no variantChange

    let outgoingHtml = '';
    let releaseTimer = null;

    const affirmEl = () => priceBlock.querySelector('.affirm-as-low-as');
    const klarnaEl = () => productInfo.querySelector('klarna-placement');

    const setDimmed = (on) => {
        affirmEl()?.classList.toggle(PENDING_CLASS, on);
        klarnaEl()?.classList.toggle(PENDING_CLASS, on);
        // Flagged on the stable block so the CSS can hold 0.5 through the moment
        // the Affirm <p> is empty, before we refill it below.
        priceBlock.classList.toggle('is-price-updating', on);
    };

    const release = () => {
        clearTimeout(releaseTimer);
        setDimmed(false);
    };

    const hold = (ms) => {
        clearTimeout(releaseTimer);
        releaseTimer = setTimeout(release, ms);
    };

    productInfo.addEventListener('change', (event) => {
        if (!event.target.closest('variant-radios, variant-selects')) return;
        const el = affirmEl();
        outgoingHtml = el && el.textContent.trim() ? el.innerHTML : '';
        setDimmed(true);
        hold(FALLBACK_MS);
    });

    // Published synchronously right after product-info.js swaps the price markup,
    // so refilling here happens in the same task: the line never paints empty.
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const el = affirmEl();
        if (!el) return;

        if (outgoingHtml && !el.textContent.trim()) {
            el.innerHTML = outgoingHtml;
            el.classList.add(PENDING_CLASS);
        }

        // Re-price Affirm now instead of waiting on affirm-product-update.js's
        // timers, so the new figure lands inside the dimmed window.
        if (data.variant) el.setAttribute('data-amount', data.variant.price);
        if (window.affirm?.ui?.refresh) window.affirm.ui.refresh();

        hold(RENDER_MS);
    });
});
